
import React, { createContext, useContext } from 'react';
import useNotification from '../hooks/useNotification';
import NotificationSnackbarV1 from '../utils/NotificationSnackbarV1';

const NotificationContext = createContext();

export const useNotificationContext = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const { notification, showNotification, hideNotification } = useNotification();

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationSnackbarV1
        open={notification.open}
        message={notification.message}
        severity={notification.severity}
        onClose={hideNotification}
        autoHideDuration={notification.autoHideDuration}
        anchorOrigin={notification.anchorOrigin}
      />
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
